import EventBus from '@/eventBus';

export const AjaxHelpersVue = {
  data() {
    return {
      //pageLoaded: false

      h1: ''
    }
  },

  methods: {
    /*isDev(staticUrl) {
      let hostName = window.location.hostname;

      return (hostName === 'localhost') || (hostName === staticUrl);
    },*/

    req(api, data, callback, blockId) {
      data = data || {};

      EventBus.$emit('preloaderShow');

      PrologueClient.queryToServer(api, data, res => {

        if(!this.check404(res) && blockId !== 'page404') {
          EventBus.$emit('load404Page');

          return false;
        }

        if(api !== 'Booking:reserveVisit' && api !== 'Event:getEvent' && api !== 'Action:getAction' && api !== 'MenuPage:loadMenu') {
          // Данные для хедера и главного меню
          EventBus.$emit('pageLoaded', {
            header: res.header,
            menuTop: res.menuTop,
          });

          // Установить meta для страницы
          if(this.checkProperty(res.meta)) {
            this.setMeta(res.meta);
          }

          // Первая загрузка
          this.setPageLoaded();

          this.setPageBlockVisible(blockId);

          this.sendStatistic();
        }

        if($.isFunction(callback)) {
          callback(res);
        }

        EventBus.$emit('preloaderHide');
      });
    },

    sendStatistic() {
      $.ajax({
        url: 'https://panel.neboavax.ru' + window.location.pathname,
        type: 'post',
        global: false,
        dataType: 'html',
        data: {
          prologueMetrika: 1,
        },
        success: function(data) {

        }
      });
    },

    check404(res) {
      if(this.checkProperty(res.status) && res.status == '404') {
        return false;
      }

      return true;
    },

    // Выбор активного блока для страницы
    setPageBlockVisible(blockId) {
      $('.page__item--active').removeClass('page__item--active');

      let $activeBlock = $(`.page__item[data-id=${blockId}]`);
      $activeBlock.addClass('page__item--active');

      $('body, .page').attr('data-block', blockId);
    },

    setMeta(res) {
      if(res.title.length) {
        $('title').text(res.title);
      }

      if(res.description.length) {
        $('[name="description"]').attr('content', res.description);
      }

      if(res.h1.length) {
        this.h1 = res.h1;
      }
    },

    // Для первой загрузки
    setPageLoaded() {
      let $page = $('.page');

      if(!$page.hasClass('page--loaded')) {
        $page.addClass('page--loaded');

        //this.pageLoaded = true;
      }
    },

    checkProperty(prop) {
      return typeof(prop) !== 'undefined' && $.type(prop) !== 'null';
    },

    /**
     * Проверка загрузки изображений
     * @param objImages {object}
     * @returns {Promise}
     * @description Формат принимаего объекта, где loaded - статус изображения по-умолчанию не загружен; src - ссылка на изображение
     var objImages = [
     {
       loaded: false,
       src: img1Src
     },
     {
       loaded: false,
       src: img2Src
     }
     ];
     */
    checkImgLoading(objImages) {
      return new Promise((resolve, reject) => {
        let loaded = false;

        $.each(objImages, (i, el) => {
          $('<img />').attr('src', el.src).on('load', function() {
            $(this).remove();

            objImages[i].loaded = true;
          });
        });

        let int = setInterval(() => {
          $.each(objImages, (i, el) => {
            loaded = el.loaded ? true : false;
          });

          if(loaded) {
            clearInterval(int);

            // Все изображения загрузились, резолвим
            resolve();
          }
        }, 250);
      });
    }
  }
};
